/* eslint-disable @typescript-eslint/no-unused-vars */
import './TemplateSummary.scss'
import { Icon, IconButton } from '@/ui-legacy'
import { ENDPOINTS } from '@/util'
import { useSessionStorage } from '@/hooks'
import { MessagesStorageStorageFileType } from '@/util/enums'
import { toast } from 'sonner'
import DOMPurify from 'isomorphic-dompurify'
import clsx from 'clsx'
import { usePlatformOutletContext } from '../Platform/usePlatFormOutletContext'
import { RestSchemas } from '@/contexts/QueryProvider'

type MessagesTemplatesTTemplateActivity = RestSchemas['Messages.Templates.TTemplateActivity']

type TemplateSummaryProps = {
  selected: boolean
  onClick: (entityId: number, templateId: number, entityType: string) => void
  appId: number | null
} & MessagesTemplatesTTemplateActivity

export const TemplateSummary = (props: TemplateSummaryProps) => {
  const { projectId } = usePlatformOutletContext()
  const [token] = useSessionStorage('token', '')

  const onDownloadClick = async () => {
    // TODO - error check appId and projectid
    const fileType: MessagesStorageStorageFileType = 1

    try {
      const response = await fetch(
        `${ENDPOINTS.LANDING}/storage/download_file/${props.url},${props.appId},${projectId},${fileType}`,
        {
          headers: { Authorization: 'Bearer ' + token },
        }
      )
      if (response.ok) {
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('download', props.file_name ?? 'filename.txt')
        document.body.appendChild(a)
        a.click()
        a.remove()
      } else {
        let errMessage = 'Unknown error'
        if (response.statusText) errMessage = response.statusText
        try {
          const tryJson = await response.json()
          if (tryJson.Message) errMessage = tryJson.Message
        } catch (error) {
          // ignore
        }
        toast.error('Error downloading file: ' + DOMPurify.sanitize(errMessage))
      }
    } catch (error) {
      toast.error(`Error downloading file: ' + ${DOMPurify.sanitize(`${error}`)}`)
      console.error(DOMPurify.sanitize(`${error}`))
    }
  }

  return (
    <div
      className={clsx('ux-template-summary', props.selected && 'selected')}
      onClick={() => props.onClick(props.entity.id, props.file_template.id, props.entity.entity_type.name)}
    >
      <div className="justify-between">
        <div>
          <div className="label">{props.entity.name}</div>
          <div className="ftname">{props.file_template.name}</div>
          <div className="filename ellipsis">{props.file_name}</div>
        </div>
        <div className="action-container">
          {props.state === 'None' && <Icon icon="time-outline" color="#E8E8E8" />}
          {props.state === 'Uploaded' && <Icon icon="search-outline" color="#FFBF1F" />}
          {props.state === 'Accepted' && <Icon icon="circle-checkmark-outline" color="#22922E" />}
          {props.state === 'Returned' && <Icon icon="arrow-left-outline" color="#FFE5A5" />}

          {props.url && <IconButton icon="download-outline" onClick={onDownloadClick} />}
        </div>
      </div>
    </div>
  )
}

export default TemplateSummary
